module.exports = __webpack_public_path__ + "img/tooltip.11d3cf87.svg";